import classNames from 'classnames';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { QuotedSelectionHighlight } from 'APP/main/ChatView/Messages/Message/components/QuoteSelectionHighlight/QuotedSelectionHighlight';
import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

import usePresenter from './presenter';
import styles from './styles.m.css';

const Album = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  const { typeDescription, comment } = message.payload;
  const presenter = usePresenter(message);

  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      imageUrl={presenter.imageUrl}
      graphicSize={presenter.graphicSize}
      title={title}
      text={typeDescription}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    >
      {comment && (
        <QuotedSelectionHighlight
          highlightedText={message.highlightedText}
          originalText={comment}
          groupId={message.groupId}
        >
          <TextRenderer
            isPlainText
            className={classNames(styles.text, textClassName)}
          >
            {comment}
          </TextRenderer>
        </QuotedSelectionHighlight>
      )}
    </MiniatureMessageLayout>
  );
};

export default Album;
